import * as React from 'react';

import styles from './OutputLabel.less';

interface OwnProps {
  text: string;
}

type Props = OwnProps;

export const OutputLabel: React.FC<Props> = ({text}) => {
  return <div className={styles.dlOutputLabel}>{text}</div>;
};

OutputLabel.displayName = 'OutputLabel';
